import * as actionType from './type';

const INITIAL_STATE = {
    isLoading: false,
    error: "",
    salesOrder: [],
}

export default function(state = INITIAL_STATE, action) {
    switch(action.type) {
        case actionType.REQUEST_GET_ALL_SO: {
            return {
                ...state,
                isLoading: true
            }
        }

        case actionType.RECEIVED_ALL_SO: {
            return {
                ...state,
                isLoading: false,
                salesOrder : action.payload
            }
        }

        case actionType.RECEIVED_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: "Please try again"
            }
        }

        default: 
            return state;
    }
}